import { Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WarehouseStorageRate } from '../../models/warehouse-storage-rate.model';
import { WarehouseStorageRateService } from '../../services/warehouse-storage-rate.service';
import { AccountService } from 'src/app/account/services/account.service';

@Component({
    selector: 'app-storage-rate-form',
    templateUrl: './storage-rate-form.component.html',
    styleUrls: ['./storage-rate-form.component.scss'],
    standalone: false
})
export class StorageRateFormComponent implements OnInit {

  @Input()
  rate: WarehouseStorageRate;

  accounts: any[] = [];
  units: any[] = [];
  products: any[] = [];

  constructor(private storageRateService: WarehouseStorageRateService,
    private accountService: AccountService) { }

  ngOnInit(): void {
    this.accountService.getAllAccountsForCustomerAndProspect()
      .pipe(take(1))
      .subscribe((accounts: any) => {
        this.accounts = accounts;
      });

    this.storageRateService.getAllUnits()
      .pipe(take(1))
      .subscribe((units: any[]) => {
        this.units = units;
      });

    this.storageRateService.getAllProducts()
      .pipe(take(1))
      .subscribe((products: any[]) => {
        this.products = products;
      });
  }
}
